// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2zqlv","signatureButtonsRight":"ModalSign_signatureButtonsRight__3rvtS"};